import { render } from "./MetricText.vue?vue&type=template&id=3f5a1b71&scoped=true"
import script from "./MetricText.vue?vue&type=script&lang=js"
export * from "./MetricText.vue?vue&type=script&lang=js"

import "./MetricText.vue?vue&type=style&index=0&id=3f5a1b71&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f5a1b71"]])

export default __exports__